import { useAccessConditions } from '@/creditflowresearch/ui/common/hooks/access/useAccessConditions';
import { useLockDetection } from '@/creditflowresearch/ui/common/hooks/title/useLockDetection';
import { type IAccessCondition } from '@/creditflowresearch/ui/common/hooks/access/useAccessConditions';
import { type IActiveItem } from '@/creditflowresearch/ui/common/hooks/filters/useFilterButtons';

interface IUseProductPageAccessOptions {
  activeProductItems: IActiveItem[],
  accessConditions?: IAccessCondition[],
  blockingAccessConditions?: IAccessCondition[],
}

interface IUseProductPageAccessResult {
  shouldShowLock: boolean,
  hasBlockingAccessFailure: boolean,
}

export const useProductPageAccess = ({
  activeProductItems,
  accessConditions,
  blockingAccessConditions,
}: IUseProductPageAccessOptions): IUseProductPageAccessResult => {
  const { accessConditionsList, hasAccessConditions } = useAccessConditions({
    accessConditions,
    defaultFallback: null,
  });

  const { shouldShowLock, hasBlockingAccessFailure } = useLockDetection({
    activeItems: activeProductItems,
    accessConditionsList,
    hasAccessConditions,
    blockingAccessConditions,
  });

  return {
    shouldShowLock,
    hasBlockingAccessFailure,
  };
};
